import AddIcon from "@mui/icons-material/Add";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import { Box, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useState } from "react";
import AddFamilyMembers from "./AddFamilyMember/AddFamilyMember";
import AddProperty from "./AddProperty/AddProperty";
import AddVehicle from "./AddVehicle/AddVehicle";
import "./Profile.scss";
import VehicleBox from "./VehicleBox/VehicleBox";
import EditFamilyMember from "./EditFamilyMember/EditFamilyMember";

function Profile() {
  const [addNewMember, setaddNewMember] = useState(false);
  const [addNewVehicle, setaddNewVehicle] = useState(false);
  const [hideDataStatus, setHideDataStatus] = useState(false);
  const [addProperty, setAddProperty] = useState(false);
  const [editMember, setEditMember] = useState(false);
  const [selectedMember, setSelectedMember] = useState(0);
  const [selectedProperty, setSelectedProperty] = useState(0);

  const memberList: {
    name: string;
    relation: string;
    dob: string;
    class_name: string;
  }[] = [
    {
      name: "Devansh Raghuvanshi",
      relation: "Son",
      dob: "01/01/2000",
      class_name: "son",
    },
    {
      name: "Rajinder Raghuvanshi",
      relation: "Father",
      dob: "01/01/1975",
      class_name: "father",
    },
  ];

  const propertyList: { title: string; class_name: string }[] = [
    { title: "Rented", class_name: "rented" },
    { title: "Flat", class_name: "rented" },
    { title: "Independent House", class_name: "independent" },
    { title: "I live with parents", class_name: "parenthouse" },
  ];
  const propertyDetails = [
    { title: "Property Type", desc: "Owned" },
    { title: "Property Age", desc: "1-5 Years" },
    { title: "Building/Street Name", desc: "341 valliant tower" },
    { title: "Area Name", desc: "phase 9 industrial area" },
    { title: "Country", desc: "India" },
    { title: "State", desc: "U.K." },
    { title: "Zip Code", desc: "248142" },
  ];

  const memberClick = (index: number) => {
    setSelectedMember(index);
  };

  const handleClick = (index: number) => {
    setSelectedProperty(index);
  };

  const updateMasterState = (attrName: any, value: any) => {
    if (attrName === setaddNewMember) {
      setaddNewMember(value);
      setHideDataStatus(value);
    } else {
      attrName(value);
    }
  };

  return (
    <>
      <Grid xs className="profileWrapper">
        <Grid container spacing={3}>
          <Grid xs={12}>
            <Box className="pageTitle">
              <h2>
                <span>Your</span> Profile
              </h2>
              <p>Information about a your life, work, interests, etc.</p>
            </Box>
          </Grid>

          {/* Personal Details */}
          <Grid xs={12} display="flex" alignItems="flex-start">
            <Box className="personalInfo">
              <div className="myimg">
                {/* <PersonIcon className="icon" /> */}
                <img src="./images/rahul.jpg" />
              </div>
              <div className="myDeails">
                <Link className="camera">
                  <PhotoCameraOutlinedIcon />
                  <input type="file" />
                </Link>
                <h4>Rahul Raghuvanshi</h4>
                <p>EV003</p>
                <p>UI/UX Designer, Design</p>
              </div>
            </Box>
            <Box className="personalDetails">
              <ul>
                <li className="dob">14th Sep 1986</li>
                <li className="gender">Male</li>
                <li className="marital">Married</li>
                <li className="address">
                  #6, Building name, Area, Street name, City - 123456, India
                </li>
              </ul>
              <div className="ml-0 mr-2" style={{ textAlign: "end" }}>
                <Link className="blueBtn edit">Edit</Link>
              </div>
            </Box>

            <Box className="familyMembers">
              <h4>Family Members</h4>
              <ul>
                <li
                  className="addMore"
                  onClick={() => {
                    updateMasterState(setaddNewMember, true);
                  }}
                >
                  <AddIcon />
                </li>
                {memberList.map((item, index) => (
                  <li
                    key={index}
                    className={
                      selectedMember === index
                        ? `${item.class_name} active`
                        : `${item.class_name}`
                    }
                    onClick={() => memberClick(index)}
                  ></li>
                ))}
              </ul>
              <Box className="memberDetails">
                <span>{memberList[selectedMember].name}</span>{" "}
                <span>{memberList[selectedMember].relation}</span>{" "}
                <span>{memberList[selectedMember].dob}</span>
                <Link
                  className="blueBtn edit"
                  onClick={() => {
                    setEditMember(true);
                  }}
                >
                  Edit
                </Link>
              </Box>
            </Box>
          </Grid>
          <Grid xs={7}>
            <div className="salary_details">
              <img
                src="./images/professiondetail_icon.svg"
                alt=""
                height={30}
              />
              <ul>
                <li> ₹ 1,00,000</li>
                <li> Oct-20-2019</li>
                <li> 9876541230</li>
                <li> Vikas.saini@evervent.in</li>
              </ul>
            </div>
          </Grid>
        </Grid>

        {/* Add Vehicles */}
        <Grid container spacing={3}>
          <Grid xs={12}>
            <Box className="subHeading mb-4">
              <h3>
                <span>Vehicles</span>
                <Link
                  className="blueBtn addfile"
                  onClick={() => {
                    updateMasterState(setaddNewVehicle, true);
                  }}
                >
                  Add
                </Link>
              </h3>
              <p>
                List your vehicles here, so that we can remind you for the
                insurance policy renewal.
              </p>
            </Box>
          </Grid>
          <Grid xs={12}>
            <VehicleBox
              regno="HR 85 ab 1234"
              vehicleType="carIcon"
              makeModel="Land Rover Range Rover Evoque"
              variant="Diesel, 2.2 Dynamic Plus 4 WD, 2179 CC"
              nofdays="120"
            />
            <VehicleBox
              regno="pb 01 ab1234"
              vehicleType="bikeIcon"
              makeModel="Royal Enfield 535 Lightning"
              variant="535 Lightning, 499 cc"
              nofdays="86"
            />
          </Grid>
        </Grid>

        {/* Add Property */}
        <Grid container spacing={3}>
          <Grid xs={12}>
            <Box className="subHeading mb-4">
              <h3>
                <span>House</span>
                <Link
                  className="blueBtn addfile"
                  onClick={() => {
                    setAddProperty(true);
                  }}
                >
                  Add
                </Link>
              </h3>
              <p>Which type of property do you have?</p>
            </Box>
          </Grid>
          <Grid xs={12}>
            <ul className="propertyType">
              {propertyList.map((item, index) => (
                <li
                  key={index}
                  className={
                    selectedProperty === index
                      ? `${item.class_name} active`
                      : `${item.class_name}`
                  }
                  onClick={() => handleClick(index)}
                >
                  {item.title}
                </li>
              ))}
            </ul>
          </Grid>
          <Grid xs={12}>
            <ul className="property_details">
              {propertyDetails.map((data, index) => (
                <li>
                  <p>
                    {data.title}
                    <span>{data.desc}</span>
                  </p>
                </li>
              ))}
            </ul>
          </Grid>
        </Grid>

        <AddFamilyMembers
          open_status={addNewMember}
          attrName={setaddNewMember}
          value_update={updateMasterState}
        />
        <AddVehicle
          open_status={addNewVehicle}
          attrName={setaddNewVehicle}
          value_update={updateMasterState}
        />

        <AddProperty
          open_status={addProperty}
          attrName={setAddProperty}
          value_update={updateMasterState}
        />
        <EditFamilyMember
          open_status={editMember}
          attrName={setEditMember}
          value_update={updateMasterState}
        />
      </Grid>
    </>
  );
}

export default Profile;
